module.exports = __webpack_public_path__ + "static/media/w2.ce095b17.svg";